module.exports = __webpack_public_path__ + "static/media/icons_Bilan Course … pied.892067e9.svg";